import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getDelivery = (params) => {
  return axios.request({
    url: `/common/library/getDelivery`,
    method: "get",
		params
  });
};
